module.exports = __webpack_public_path__ + "static/egghead-ccdd804c87d12f9e024c9cc532e795a3.png";